module.exports = __webpack_public_path__ + "img/preview-thyroid-collars.240fd882.png";